// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__ojcB9","checkboxCol":"Table_checkboxCol__27Tpr","emailCol":"Table_emailCol__1QAfY","actionCol":"Table_actionCol__10Zdy"};